import {
    type EquipmentActionsType,
    FETCH_EQUIPMENT_FAILED,
    SET_CONTENT_VIEW_MODE,
    SET_OPTIONAL_EQUIPMENT,
    SET_SELECTED_CAR,
    SET_STANDARD_EQUIPMENT,
} from "../actions/EquipmentActions";
import type { EquipmentCategoryType, SelectedCarType } from "../../utils/types";
import { ContentViewMode } from "../../utils/constants";

export type EquipmentReducerType = {
    loaded: boolean;
    error: boolean;
    selectedCar: SelectedCarType;
    contentViewMode: ContentViewMode;
    standard: EquipmentCategoryType[];
    optional: EquipmentCategoryType[];
};
export const initialEquipmentState: EquipmentReducerType = {
    loaded: false,
    error: false,
    contentViewMode: ContentViewMode.Thumbs,
    selectedCar: {
        modelId: "",
        carId: "",
        colourId: "",
    },
    standard: [],
    optional: [],
};

const EquipmentReducer = (
    state: EquipmentReducerType = initialEquipmentState,
    action: EquipmentActionsType,
): EquipmentReducerType => {
    switch (action.type) {
        case SET_SELECTED_CAR:
            return {
                ...state,
                selectedCar: action.car,
            };

        case SET_CONTENT_VIEW_MODE:
            return {
                ...state,
                contentViewMode: action.contentViewMode,
            };

        case SET_STANDARD_EQUIPMENT:
            return {
                ...state,
                loaded: true,
                standard: action.categories,
            };

        case SET_OPTIONAL_EQUIPMENT:
            return {
                ...state,
                loaded: true,
                optional: action.categories,
            };

        case FETCH_EQUIPMENT_FAILED:
            return { ...state, loaded: true, error: true };

        default:
            return state;
    }
};

export default EquipmentReducer;
